var _defs, _rect, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginFootballArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 86,
    y1: 65,
    x2: 820,
    y2: 846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D111E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shine",
    x1: 170,
    y1: 108,
    x2: 650,
    y2: 760,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 24,
    stdDeviation: 24,
    floodColor: "#2D2D2E",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    rx: 48,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-85 185L545 -54L969 182L968 337L383 588L-85 351V185Z",
    fill: "url(#shine)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-112 770L431 530L971 705V950H-112V770Z",
    fill: "#2D2D2E",
    fillOpacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 112,
    width: 690,
    height: 676,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 113V788"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 112
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 8,
    fill: "white",
    fillOpacity: 0.28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 309H232C274 309 308 343 308 385V515C308 557 274 591 232 591H105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 309H668C626 309 592 343 592 385V515C592 557 626 591 668 591H795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 374H174C198 374 218 394 218 418V482C218 506 198 526 174 526H105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 374H726C702 374 682 394 682 418V482C682 506 702 526 726 526H795"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 679C248 625 314 617 377 624",
    strokeOpacity: 0.18,
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 713C278 669 337 658 388 663",
    strokeOpacity: 0.32,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 194C694 235 734 283 756 337",
    strokeOpacity: 0.22,
    strokeWidth: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 635,
    r: 128,
    fill: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 635,
    r: 124,
    stroke: "#2D2D2E",
    strokeOpacity: 0.12,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 573L501 613L480 679H410L389 613L445 573Z",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 613L336 598L313 646L345 690L410 679",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 613L554 598L577 646L545 690L480 679",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 573L415 523L359 542L336 598L389 613",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 573L475 523L531 542L554 598L501 613",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 690L365 744L425 758L445 713L410 679",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 690L525 744L465 758L445 713L480 679",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#ADADB2",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 573L445 515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 613L336 598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 613L554 598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 679L345 690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 679L545 690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 713V763"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 249,
    r: 14,
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 346,
    r: 11,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651,
    cy: 326,
    r: 14,
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 702,
    cy: 538,
    r: 11,
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 531,
    r: 10,
    fillOpacity: 0.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeOpacity: 0.42,
    strokeWidth: 3,
    strokeDasharray: "8 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 258C287 288 311 313 329 346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 340C683 401 702 463 702 526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 528C300 511 340 493 374 468"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(132 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 62,
    rx: 18,
    fill: "#2D2D2E",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 41,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 800
  }, "FOOTSKILL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFootballArt);
export default __webpack_public_path__ + "static/media/login-football-art.1c95ce6fb4b075defca34deeef8bd31e.svg";
export { ForwardRef as ReactComponent };